var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_66",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m36.098,32.681l.783,54.506c.007.508.422.917.93.917h23.225c.509,0,.923-.408.93-.917l.903-62.851c.007-.519-.411-.944-.93-.944h-16.571",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m36.098,38.699l3.597-1.382c3.078-1.182,6.462-1.311,9.621-.367h0c3.747,1.12,7.785.724,11.243-1.104l2.132-1.127",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "30.242", y1: "17.556", x2: "32.121", y2: "19.436" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "35.012", y1: "15.58", x2: "35.012", y2: "18.239" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "39.783", y1: "17.556", x2: "37.903", y2: "19.436" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "28.266", y1: "22.327", x2: "30.924", y2: "22.327" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "30.242", y1: "27.098", x2: "32.121", y2: "25.218" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m36.908,23.392h8.461c.307-3.008-.688-6.124-2.993-8.429-4.067-4.067-10.661-4.067-14.728,0s-4.067,10.661,0,14.728c2.31,2.31,5.435,3.304,8.449,2.99l-.12-8.345c-.007-.519.411-.944.93-.944Z",
        },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "47.734 75.103 56.021 15.385 64.18 13.972" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }